import React from 'react'
import { Link } from 'react-router-dom'
import { CallToAction } from '@scentregroup/ui'
import { PRODUCTS } from '../../paths'
import Footer from '../footer'
import WestfieldPlusJoinNow from '../westfield-plus-join-now'
import { CountryContext } from '../../context'
import style from './index.module.scss'

const NationalFooter = ({ ...restProps }) => (
  <CountryContext.Consumer>
    {country => (
      <Footer {...restProps}>
        {country === 'Australia' && (
          <div className={style.productButtonWrapper}>
            <CallToAction
              inverted
              fullWidth
              className={style.productButton}
              element={Link}
              to={PRODUCTS}
              data-test-id="products-button"
            >
              Products
            </CallToAction>
          </div>
        )}
        <WestfieldPlusJoinNow />
      </Footer>
    )}
  </CountryContext.Consumer>
)

export default NationalFooter
